export default "__VITE_ASSET__OHhzjiiL__"